import MicroModal from 'micromodal';

// MicroModalの初期化
// DOMContentLoadedの後に実行しないとトリガー要素が見つからない
// 注意: MicroModalのonShowは実際には3つの引数を受け取る（型定義は不完全）
// 1番目: modal要素, 2番目: activeElement, 3番目: イベント
document.addEventListener('DOMContentLoaded', () => {
  MicroModal.init({
    // onShowは3つの引数を受け取る: modal, activeElement, event
    onShow: ((
      modal: HTMLElement,
      _activeElement: HTMLElement,
      event: Event
    ) => {
      if (!event || !modal) return;

      // クリックされた要素からトリガーボタンを探す
      const target = event.target as HTMLElement;
      const trigger = target.closest('[data-modal-template-id]');
      if (!trigger) return;

      const templateId = trigger.getAttribute('data-modal-template-id');

      if (!templateId) return;

      // テンプレートを取得
      const template = document.getElementById(
        templateId
      ) as HTMLTemplateElement;
      if (!template) return;

      // モーダルコンテンツ領域を取得
      const contentsArea = modal.querySelector('#modal-movie-contents');
      if (!contentsArea) return;

      // テンプレートの内容をクローンして差し込む
      const clone = template.content.cloneNode(true);
      contentsArea.appendChild(clone);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any,
    onClose: (modal) => {
      if (!modal) return;

      // コンテンツをクリア（iframe動画を停止）
      const contentsArea = modal.querySelector('#modal-movie-contents');
      if (contentsArea) {
        contentsArea.innerHTML = '';
      }
    },
    openTrigger: 'data-micromodal-trigger',
    closeTrigger: 'data-micromodal-close',
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: false,
    awaitCloseAnimation: false,
  });
});
